var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_176_155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 15.5303H0.5V16.0002H0V15.5303Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5623 15.5299V4.25342H11.2826V7.06226H11.7513V4.72217H14.0936V15.5299H11.7513V7.53101H11.2826V15.5299H9.63988V8.47017H6.36013V15.5299H4.71906V13.1724H4.25031V15.5299H1.90809V10.8149H4.25034V12.6873H4.71909V10.3462H1.43934V15.5299H0.96875V15.9998H16V15.5299H14.5623ZM6.82888 8.93892H9.17109V15.5299H6.82888V8.93892Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3018 0.838781L13.5564 2.3595L14.0188 2.28206L13.6366 0L11.3546 0.382125L11.432 0.844437L12.8981 0.598938C11.5933 2.50697 9.98657 4.15462 8.11698 5.50059C5.83923 7.14041 3.18945 8.294 0.454102 8.83663L0.545289 9.29641C3.34604 8.74081 6.05898 7.55978 8.39085 5.88103C10.3128 4.49734 11.9632 2.80228 13.3018 0.838781Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.37598 11.2812H2.84473V11.75H2.37598V11.2812Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29688 9.40625H7.76562V9.875H7.29688V9.40625Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2275 5.1875H12.6963V5.65625H12.2275V5.1875Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_176_155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenue);
export default __webpack_public_path__ + "static/media/revenue.eee0fee237b1c7365d29d3bafe3d26cc.svg";
export { ForwardRef as ReactComponent };